<template>
  <div class="product-widget mb-30">
    <h5 class="pt-title">Choose Brand</h5>
    <div class="widget-category-list mt-20">
      <div class="single-widget-category pointer" v-for="brand in brands_data" :key="brand.id">
        <input
          type="checkbox"
          :id="`brand-item-${brand.id}`"
          :checked="String(activeBrand) === String(brand.id)"
        >
        <label @click="handleBrandRoute(brand.id)" :for="`brand-item-${brand.id}`" class="pointer">
          {{ brand.name }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductBrands",
  data() {
    return {
      brands_data: [], // Initialize as an empty array
      activeBrand: "",
    }
  },
  watch: {
    "$route.query.web_category": {
      handler(newWebCategory) {
        this.fetchBrands(newWebCategory) // Fetch brands when web_category changes
      },
      immediate: true, // Trigger on initial load
    },
    "$route.query.brand": {
      handler(newBrand) {
        this.activeBrand = newBrand || '' // Update activeBrand when the brand changes
      },
      immediate: true, // Trigger on initial load
    },
  },
  methods: {
    async fetchBrands(web_category = this.$route.query.web_category) {
      try {
        const category = this.$route.query.category // Get category from the query (if exists)
        const response = await this.$axios.get('/website-prodcut-brands', {
          params: { category, web_category }, // Pass category and web_category as query parameters
        })
        this.brands_data = response.data
      } catch (error) {
        console.error("Error fetching brands:", error)
      }
    },
    handleBrandRoute(value) {
      const currentQuery = { ...this.$route.query } // Get existing query params
      currentQuery.brand = value // Update the brand query param

      this.$router.push({
        path: '/shop',
        query: currentQuery, // Keep existing query parameters (including web_category)
      })
    },
    formatUrl(value) {
      return value.toLowerCase().replace(/\s+/g, '-')
    },
  },
  mounted() {
    this.activeBrand = this.$route.query.brand // Set active brand from the route query
    this.fetchBrands() // Fetch brands when the component is mounted
  },
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}

/* Luxury selectable cards for filters */
.product-widget {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 252, 1) 100%);
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 16px;
  box-shadow: 0 14px 36px rgba(2, 6, 23, 0.06);
  padding: 16px;
}

.pt-title {
  color: #0f172a;
  font-size: 14px;
  font-weight: 900;
  letter-spacing: -0.01em;
  margin: 0 0 14px 0;
  box-shadow: none !important;
}

.pt-title::before,
.pt-title::after {
  content: none !important;
  display: none !important;
}

/* Selected-state indicator: small round icon + check */
.single-widget-category label::before {
  content: "";
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid rgba(15, 23, 42, 0.16);
  background: rgba(15, 23, 42, 0.03);
  transition: 0.2s ease;
}

.single-widget-category label::after {
  content: "✓";
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 50%;
  color: #ffffff;
  font-size: 12px;
  font-weight: 900;
  opacity: 0;
  transition: 0.2s ease;
}

.widget-category-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.single-widget-category {
  position: relative;
}

.single-widget-category input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.single-widget-category label {
  cursor: pointer;
  user-select: none;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0;
  position: relative; /* anchor pseudo-element icon */
  padding: 10px 12px 10px 42px; /* space for round indicator */
  border-radius: 12px;
  border: 1px solid rgba(15, 23, 42, 0.10);
  background: rgba(255, 255, 255, 0.55);
  transition: 0.2s ease;
  color: rgba(15, 23, 42, 0.88);
}

.single-widget-category label:hover {
  transform: translateY(-1px);
  border-color: rgba(252, 190, 0, 0.55);
}

.single-widget-category input:checked + label {
  border-width: 2px;
  border-color: var(--fe-accent, #fcbe00);
  color: #0f172a;
  font-weight: 800;
  background: linear-gradient(
    135deg,
    color-mix(in srgb, var(--fe-accent, #fcbe00) 42%, transparent) 0%,
    color-mix(in srgb, var(--fe-accent, #fcbe00) 18%, rgba(255, 255, 255, 0.97)) 52%,
    rgba(255, 255, 255, 0.94) 100%
  );
  box-shadow:
    0 0 0 1px color-mix(in srgb, var(--fe-accent, #fcbe00) 35%, transparent) inset,
    0 10px 28px color-mix(in srgb, var(--fe-accent, #fcbe00) 28%, transparent),
    0 20px 48px rgba(15, 23, 42, 0.08);
}

.single-widget-category input:checked + label::before {
  border-color: color-mix(in srgb, var(--fe-accent, #fcbe00) 90%, #111);
  background: linear-gradient(
    135deg,
    color-mix(in srgb, var(--fe-accent, #fcbe00) 96%, #fff) 0%,
    color-mix(in srgb, var(--fe-accent-hover, #e5ac00) 85%, #ff7a00) 100%
  );
  box-shadow:
    0 0 0 2px rgba(255, 255, 255, 0.55) inset,
    0 10px 22px color-mix(in srgb, var(--fe-accent, #fcbe00) 35%, transparent);
}

.single-widget-category input:checked + label::after {
  opacity: 1;
}
</style>